import { ReactElement, useContext, useEffect, useState } from 'react';
import {
    InteractionMode,
    StaticTreeDataProvider,
    Tree,
    UncontrolledTreeEnvironment,
} from "react-complex-tree";
import "react-complex-tree/lib/style-modern.css";
import { Box, Grid } from "@mui/material";
import { AlertSrv, FxButton, FxCheckbox, FxSelect, session, useNavigation } from "../../components/fx";
import { ControlService } from "../../services/ControlService";
import _ from "lodash";
import { useParams } from "react-router-dom";
import { TokenContext } from '../../context-helpers/TokenContext';

const RoleControlMap = (props: any) => {
    const { getToken } = useContext(TokenContext);
    const controlService = ControlService({ getToken });
    const params: any = useParams();
    const { back } = useNavigation();

    let defaultIsLoading: any = false;
    const [isLoading, setIsLoading] = useState(defaultIsLoading);

    let defaultExpandedItems: any = [];
    const [expandedItems, setExpandedItems] = useState(defaultExpandedItems);

    let defaultLookup: any = {
        Controls: []
    };
    const [lookup, setLookup] = useState(defaultLookup);
    const handleLookupChange = (data: any) => {
        setLookup((prevState: any) => {
            return { ...prevState, ...data };
        })
    };

    let defaultTreeConfig: any = {};
    const [treeConfig, setTreeConfig] = useState(defaultTreeConfig);

    let defaultRole: any = {};
    const [role, setRole] = useState(defaultRole);

    let defaultCurrenctContext: any = {
        _id: params._id,
        role: params.role,
        landingControlCode: ""
    };
    const [currentContext, setCurrenctContext] = useState(defaultCurrenctContext);

    const handleCurrentContextInputChange = (item: any) => {
        handleCurrentContextChange({ [item.name]: item.value });
    }
    const handleCurrentContextChange = (data: any) => {
        setCurrenctContext((prevState: any) => {
            return { ...prevState, ...data };
        })
    }

    useEffect(() => {
        getControls();
    }, [currentContext._id]);

    const getControls = async () => {
        setIsLoading(true);

        // get master controls
        let inputData: any = {
            "data": {
                "sorters": [],
                "filters": {}
            }
        }
        let controls = await controlService.getControls(inputData);

        // get selected controls
        let data: any = { roleCode: currentContext.role };
        let roleControl = await controlService.getRoleControls(data);
        setRole(roleControl.role);
        computeControls(controls && controls.items, roleControl);
    };

    const computeChangedData = (options: any) => {
        const { currentTreeConfig, finalItem, item, Controls, handleLookupChange, role } = options;
        let currentControls: any = Controls;
        item.data.selected = !item.data.selected;
        finalItem[item.index] = item;
        let itemIndex: any = _.findIndex(currentControls, { 'code': item.index });
        if (!item.data.selected && itemIndex != -1) {
            currentControls.splice(itemIndex, 1);
        } else if (itemIndex == -1) {
            if (item.data.routeRef && item.data.parentControlCode && item.data.parentControlCode == "-1" || !item.data.parentControlCode) {
                let strName: any = item.data.display;
                let lookupItem: any = { code: item.data.controlCode, text: strName };
                currentControls.push(lookupItem);
            }
            if (item.data.routeRef && item.data.parentControlCode && item.data.parentControlCode != "-1") {
                let strName: any = item.data.display;
                let parentControl: any = currentTreeConfig[item.data.parentControlCode];
                strName = parentControl.data.display + ' --> ' + strName;
                let lookupItem: any = { code: item.data.controlCode, text: strName };
                currentControls.push(lookupItem);
            }
        }

        if (item.children && item.children.length > 0) {
            for (let i in item.children) {
                let controlCode: any = item.children[i];
                let childControl = currentTreeConfig[controlCode];
                childControl.data.selected = item.data.selected ? true : false;
                finalItem[controlCode] = childControl;
                let childControlIndex: any = _.findIndex(currentControls, { 'code': childControl.index });
                if (!childControl.data.selected) {
                    if (childControlIndex != -1 || childControlIndex != "-1") {
                        currentControls.splice(childControlIndex, 1);
                    }
                } else if (childControlIndex == -1) {
                    if (childControl.data.routeRef && childControl.data.parentControlCode && childControl.data.parentControlCode != "-1") {
                        let strName: any = childControl.data.display;
                        let parentControl: any = currentTreeConfig[childControl.data.parentControlCode];
                        strName = parentControl.data.display + ' --> ' + strName;
                        let lookupItem: any = { code: childControl.data.controlCode, text: strName };
                        currentControls.push(lookupItem);
                    }
                }
            }
        } else if (item.data.parentControlCode && item.data.parentControlCode != "-1") {
            let parentControl = currentTreeConfig[item.data.parentControlCode];
            if (parentControl.children && parentControl.children.length > 0) {
                let totalSelectedItem: any = 0;
                for (let childCtrlKey of parentControl.children) {
                    let childControl = currentTreeConfig[childCtrlKey];
                    if (childControl.data.selected) {
                        totalSelectedItem = totalSelectedItem + 1;
                    }
                }
                parentControl.data.selected = totalSelectedItem > 0 ? true : false;
            }
            finalItem[item.data.parentControlCode] = parentControl;
        }
        currentControls = _.orderBy(currentControls, ['text'], ['asc']);
        let currentLandingCtrl: any = _.find(currentControls, { "code": role.landingControlCode });
        if (!currentLandingCtrl) {
            handleCurrentContextChange({ landingControlCode: "" });
        } else {
            handleCurrentContextChange({ landingControlCode: role.landingControlCode });
        }
        handleLookupChange({ "Controls": currentControls });
    };

    const toggleControlVisibility = (context: any) => {
        return (changedData: any, item: any, Controls: any, handleLookupChange: any, role: any) => {
            console.log('changedData =', changedData, " item=", item);
            let finalItem: any = {};
            let currentTreeConfig = context.treeConfig;
            computeChangedData({ currentTreeConfig, finalItem, item, Controls, handleLookupChange, role });
            context.updateTreeConfig(finalItem);
        };
    }

    const updateTreeConfig = (data: any) => {
        setTreeConfig((prevState: any) => {
            return { ...prevState, ...data }
        });
    }
    // Compute selected controls on load starts
    const computeSelectedControls = (controls: any, treeData: any) => {
        for (let control of controls) {
            if(treeData[control.controlCode] && treeData[control.controlCode].data) {
                treeData[control.controlCode].data.selected = true;
            }
        }

    };
    // Compute selected controls on load end

    // Compute control on load starts
    const computeControl = (control: any, treeData: any, parentKey: any) => {
        let item = JSON.parse(JSON.stringify(control));
        item.selected = false;

        let obj: any = {
            index: item.controlCode,
            children: [],
            data: item,
            actions: {
                toggleControlVisibility: toggleControlVisibility({ treeConfig: treeData, updateTreeConfig })
            }
        };
        treeData[item.controlCode] = obj;
        if (parentKey) {
            treeData[parentKey].children.push(item.controlCode);
        }
    }

    const computeControlsLookup = (selectedValueAry: any, treeData: any, role: any) => {
        let lookupControls: any = [];
        for (let idx in selectedValueAry) {
            let selectedValue = selectedValueAry[idx];
            let control: any = treeData[selectedValue.controlCode];
            let strName: any = control.data.display;
            if (control.data.routeRef && control.data.parentControlCode && control.data.parentControlCode != "-1") {
                let parentControl: any = treeData[control.data.parentControlCode];
                strName = parentControl.data.display + ' --> ' + strName;
                let lookupItem: any = { code: control.data.controlCode, text: strName };
                lookupControls.push(lookupItem);
            } else  if(control.data.routeRef && control.data.parentControlCode && control.data.parentControlCode == "-1"){
                let lookupItem: any = { code: control.data.controlCode, text: strName };
                lookupControls.push(lookupItem);
            }
        }
        handleCurrentContextChange({ landingControlCode: role.landingControlCode });
        lookupControls = _.orderBy(lookupControls, ['text'], ['asc']);
        handleLookupChange({ Controls: lookupControls });
    }

    const computeControls = async (masterControls: any, roleControl: any) => {
        let selectedControls: any = _.orderBy(roleControl.items, ['displayOrder'], ['asc']);
        let items: any = [];

        let expandedItems: any = [];
        let treeData: any = {
            root: {
                index: 'root',
                isFolder: true,
                children: [],
                data: 'Root item',
            }
        }

        if (selectedControls && selectedControls.length > 0) {
            for (let selectedControl of selectedControls) {
                for (let control of masterControls) {
                    if (selectedControl.controlCode == control.controlCode) {
                        items.push(control);
                        let index: any = _.findIndex(masterControls, { "controlCode": control.controlCode });
                        masterControls.splice(index, 1);
                    }
                }
            }
        }

        for (let control of masterControls) {
            items.push(control);
        }

        for (let control of items) {
            if (!control.parentControlCode || control.parentControlCode == "-1") {
                computeControl(control, treeData, "root");
            }
        }
        for (let control of items) {
            if (control.parentControlCode && control.parentControlCode != "-1") {
                computeControl(control, treeData, control.parentControlCode);
                treeData[control.parentControlCode].isFolder = true;
                let ctrlCodeIsExist: any = _.find(expandedItems, function (o) { return o == control.parentControlCode; });
                if (!ctrlCodeIsExist) {
                    expandedItems.push(control.parentControlCode);
                }
            }
        }
        computeSelectedControls(selectedControls, treeData);
        computeControlsLookup(selectedControls, treeData, roleControl.role);

        setIsLoading(false);
        setExpandedItems(expandedItems);
        setTreeConfig(treeData);
    }
    // Compute control on load end

    // Save selected controls start
    const prepareItems = (controlKey: any, items: any, count: any) => {
        let val: any = {
            roleCode: currentContext.role,
            controlCode: controlKey,
            displayOrder: count
        };
        items.push(val);
    };

    const apply = async () => {
        let items: any = [];
        let count = 1;
        let root: any = treeConfig['root'];
        if (!currentContext.landingControlCode) {
            AlertSrv.showErrorMsg("Please select Landing Control");
            return;
        }
        for (let idx in root.children) {
            let controlKey: any = root.children[idx];
            let data: any = treeConfig[controlKey] && treeConfig[controlKey].data || '';
            if (data && data.selected) {
                prepareItems(controlKey, items, count);
                count++;
            };
        };

        for (let controlKey in treeConfig) {
            let item: any = treeConfig[controlKey];
            if (controlKey != 'root' && item.children) {
                for (let childIdx in item.children) {
                    let childControlKey: any = item.children[childIdx];
                    let data: any = treeConfig[childControlKey] && treeConfig[childControlKey].data || '';
                    if (data && data.selected) {
                        prepareItems(childControlKey, items, count);
                        count++;
                    };
                }
            }
        }
        let inputData: any = { items: items, roleCode: currentContext.role, landingControlCode: currentContext.landingControlCode };
        await controlService.saveControls(inputData);
        AlertSrv.showSuccessMsg("Success");
        backToList();
    }
    // Save selected controls end

    const backToList = () => {
        back();
    }

    return (
        <div className="container-fluid">
            <Box className="content-heading">
                <Box className="page-title">Role Control Map
                    {currentContext.role &&
                        <span className="font-12 m-left-1">
                            ( {currentContext.role} )
                        </span>
                    }
                </Box>
            </Box>
            <Box className="content-body">
                <Grid container sx={{ justifyContent: "end", pr: 2 }}>
                    <Grid item xs={4} sx={{ textAlign: "right" }} className='p-right-2 p-top-1'>
                        Landing Control
                    </Grid>

                    <Grid item xs={4}>
                        <FxSelect
                            name="landingControlCode"
                            selectedValue={currentContext.landingControlCode}
                            displayField="text"
                            valueField="code"
                            options={lookup.Controls}
                            onValueChange={handleCurrentContextInputChange}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
                {isLoading &&
                    <div className='text-center m-top-4'>loading...</div>
                }
                {!isLoading && treeConfig && treeConfig.root &&
                    <>
                        <Box className="content-body-inner" sx={{ "height": "100%", "maxHeight": "100%", overflow: "auto" }}>
                            <UncontrolledTreeEnvironment
                                canDragAndDrop={true}
                                canReorderItems={true}
                                canDropOnFolder={true}
                                dataProvider={new StaticTreeDataProvider(treeConfig, (item: any, data: any) => ({ ...item, data }))}
                                getItemTitle={(item: any) => item.data.display}
                                defaultInteractionMode={InteractionMode.ClickArrowToExpand}
                                viewState={{
                                    'role-control-map': {
                                        expandedItems: expandedItems,
                                    },
                                }}
                                renderItem={({ item, title, arrow, depth, context, children }: any) => (
                                    <div
                                        {...context.itemContainerWithChildrenProps}
                                    >
                                        <div className="tree-item" {...context.itemContainerWithoutChildrenProps} {...context.interactiveElementProps}>
                                            <Box className="tree-item-arrow">{arrow}</Box>
                                            <Box sx={{ paddingLeft: "15px" }}>
                                                <FxCheckbox
                                                    className="tree-item-checkbox"
                                                    value={item.data.selected}
                                                    name={item.data.controlCode}
                                                    onValueChange={(changedData: any) => item.actions.toggleControlVisibility(changedData, item, lookup.Controls, handleLookupChange, role)}
                                                    label="" />
                                            </Box>
                                            <Box>{title}</Box>
                                        </div>
                                        <Box sx={{ paddingLeft: "15px" }}>
                                            {children}
                                        </Box>
                                    </div>
                                )}>
                                <Tree treeId="role-control-map" rootItem="root" treeLabel="Role Control Map" />
                            </UncontrolledTreeEnvironment>
                        </Box>
                        <div style={{ padding: "5px 10px 10px 0", textAlign: 'right' }}>
                            <FxButton label="Submit" variant="contained" color="primary" onClick={apply} />
                            <FxButton label="Cancel" variant="contained" className="m-left-2" color="error" onClick={backToList} />
                        </div>
                    </>
                }
            </Box>
        </div>
    );
}

export default RoleControlMap;
